$(document).ready(function () {
    $('.thumbnail').hover(function() { 
        $('.quick_shop', this).show(); 
    }, function() { 
        $('.quick_shop', this).hide(); 
    });
    quickView();

});



function quickView() {
  
    if ($('body.template-product').length > 0) {
        var crossSaleBundle = {
            bundle1: {
                variant: 1,
                qty: 1,
                sizeOption: '',
                colorOption: '',
                selectedOptions: '',
                actualPrice: 0,
                comparePrice:0
            },
            bundle2: {
                variant: 1,
                qty: 1,
                sizeOption: '',
                colorOption: '',
                selectedOptions: '',
                actualPrice: 0,
                comparePrice:0
            }
        };
    }

    if (jQuery('.crossBundleMain').length) {
        jQuery.getJSON('/products/' + $('.crossBundleMain').data('handle') + '.js', function (product) {
            jQuery.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function(cart) {
                    let items=[];
                    let productInCart = false;
                    jQuery.each(cart.items, function(item) {
                        items.push(cart.items[item].id);
                    });
                    jQuery.each(product.variants, function(variant) {
                        if ($.inArray(product.variants[variant].id, items) != -1) {
                            productInCart = true;
                        }
                    });
                    if (!productInCart) {
                        $('.crossBundle1 .prdctTitle, .crossBundle2 .prdctTitle').addClass('nonClickable');
                    }
                }
            });
        });
    }
  
    $(".quick-view").click(function (e) {
        e.preventDefault();
        
        if ($('#quick-view').length == 0) {
            $("body").append('<div id="quick-view"></div>');
        }

        // CrossSale Product   
        if ($(this).hasClass('nonClickable')) {
            var productTitle = $('.bundleErr').data('producttitle');
            $('.bundleErr').html('First Add <b>'+productTitle+'</b> and then procced to add this product.');
            $('.bundleErr').show();
            return;
        }
        else{
          $('.bundleErr').html('');
          $('.bundleErr').hide();
        }
      
        if ($(this).parents('.crossPrdct').hasClass('crossBundle1')) {
            $('#quick-view').addClass('qckCrossBundle1');
        } else if ($(this).parents('.crossPrdct').hasClass('crossBundle2')) {
            $('#quick-view').addClass('qckCrossBundle2');
        }

        var product_handle = $(this).data('handle');

        $('#quick-view').addClass(product_handle);

        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

            var title = product.title;
            var type = product.type;
            var price = 0;
            var original_price = 0;
            var desc = product.description;
            var images = product.images;
            var variants = product.variants;
            var options = product.options;
            var url = '/products/' + product_handle;

            $('.qv-product-title').text(title);
            $('.qv-product-type').text(type);
            $('.qv-product-description').html(desc.split(" ").splice(0, 30).join(" "));
            $('.view-product').attr('href', url);
            $('.quickviewCustom').append(`<script type="application/json" id="ProductJson-quickview-snippet">var quickViewProductData = ${JSON.stringify(product)};</script>`);

            var imageCount = $(images).length;

            $(images).each(function (i, image) {

                if (i == imageCount - 1) {
                    var image_embed = '<img class="lazyload" data-src="' + image + '">';

                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                    $('.qv-product-images').append(image_embed);

                    $('.qv-product-images').slick({
                        'dots': true,
                        'arrows': false,
                        'fade': true
                    }).css('opacity', '1');
                } else {
                    image_embed = '<img class="lazyload" data-src="' + image + '">';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    $('.qv-product-images').append(image_embed);
                }
            });

            $(options).each(function (ind, option) {
                var opt = option.name;
                var selectClass = '.option.' + opt.toLowerCase();

                if (opt.trim().toLowerCase() == 'size') {
                    $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><div class="swatch prdct-frm--swatch-wrap sizeOptions" data-option-index="'+ ind +'"></div>');
    
                    $(option.values).each(function (i, value) {
                        let checked = '';
                        if (i == 0) {
                            checked = 'checked';
                        }
                        let swatch = `<div class="sizeOptionWrapper" data-value="${value}"><input id="swatch-${ind}-${value.toLowerCase().replace(/\s/g, '-')}-${product.id}" type="radio" name="option-${ind}" value="${value}" ${checked}/><div data-value="${value}" class="swatch-element ${value} prdct-frm--swatch-itm"><label for="swatch-${ind}-${value.toLowerCase().replace(/\s/g, '-')}-${product.id}" class="prdct-frm--size-swatch-itm-wrap prdct-frm--swatch-itm-wrap">${value}</label></div></div>`;

                        $('.qv-product-options .swatch.sizeOptions').append(swatch);

                    });
                } else if (opt.trim().toLowerCase() == 'color' || opt.trim().toLowerCase() == 'colour') {
                    $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><div class="swatch prdct-frm--swatch-wrap colorOptions" data-option-index="'+ ind +'"></div>');
    
                    $(option.values).each(function (i, value) {
                        let checked = '';
                        if (i == 0) {
                            checked = 'checked';
                        }
                        let fImg;
                        $(variants).each(function (index, variant) {
                            if(variant.options[0] == value || variant.options[1] == value || variant.options[2] == value) {
                                fImg = variant.featured_image.src;
                            }
                        });
                        fImg = fImg.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                        let swatch = `<div class="colorOptionWrapper" data-value="${value}"><input data-src="${fImg}" id="swatch-${ind}-${value.toLowerCase().replace(/\s/g, '-')}-${product.id}" type="radio" name="option-${ind}" value="${value}" ${checked}/><div data-value="${value}" class="swatch-element ${value} prdct-frm--swatch-itm"><div class="tooltip prdct-frm--swatch-tooltip">${value}</div><div class="colorLabel"><label for="swatch-${ind}-${value.toLowerCase().replace(/\s/g, '-')}-${product.id}" class="prdct-frm--color-swatch-itm-wrap prdct-frm--swatch-itm-wrap" style="background:url(${fImg}) center no-repeat;"></label></div></div></div>`;

                        $('.qv-product-options .swatch.colorOptions').append(swatch);

                    });

                    let sizeVal = $("input[name='option-0']:checked").val();
                    let sizeVariantColors = []; 

                    eval($("#ProductJson-quickview-snippet").html());

                    $(quickViewProductData.variants).each(function (i, v) {

                        let vArray = v.title.split(' / ');
                        if (v.inventory_quantity === 0 && vArray[0] === sizeVal) {
        
                            sizeVariantColors.push(vArray[1]);
        
                        } else if (v.inventory_quantity === 0 && vArray[1] === sizeVal) {
        
                            sizeVariantColors.push(vArray[0]);
        
                        }
                    });
                }
            });

            $(product.variants).each(function (i, v) {

                if (v.inventory_quantity == 0) {
                    // $('.qv-add-button').prop('disabled', true).val('Sold Out');
                    $('.qv-product-price').html('Sold Out').show();
                    return true

                } else {

                    price = parseFloat(v.price / 100).toFixed(2);
                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

                    $('.qv-product-price').text('$' + price);

                    if (original_price > 0) {
                        $('.qv-product-original-price').text('$' + original_price).show();
                    } else {
                        $('.qv-product-original-price').hide();
                    }

                    $('select.option-0').val(v.option1);
                    $('select.option-1').val(v.option2);
                    $('select.option-2').val(v.option3);

                    return false
                }
            });
            
            $('.qv-content').show();
        });

        $(document).on("change", "#quick-view input[type=radio]", function () {

            var selectedOptions = '';

            $('#quick-view input[type=radio]:checked').each(function (i) {

                if (selectedOptions == '') {
                    selectedOptions = $(this).val();
                } else {
                    selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
            });
            
            if ($(this).attr('name') == 'option-0') {

                let sizeVal = $(this).val();
                let sizeVariantColors = []; 

                eval($("#ProductJson-quickview-snippet").html());

                $(quickViewProductData.variants).each(function (i, v) {

                    let vArray = v.title.split(' / ');
                    if (v.inventory_quantity === 0 && vArray[0] === sizeVal) {
    
                        sizeVariantColors.push(vArray[1]);
    
                    } else if (v.inventory_quantity === 0 && vArray[1] === sizeVal) {
    
                        sizeVariantColors.push(vArray[0]);
    
                    }
                });

                $(".colorOptionWrapper").each(function(i, c) {

                    let colorVal = $(this).data('value');
                    if($.inArray(colorVal, sizeVariantColors) >= 0) {
                        $(this).addClass('hidden');
                    } else {
                        $(this).removeClass('hidden');
                    }

                });

            }

            if ($(this).attr('name') == 'option-1') {

                let imgSrc = $(this).data('src').replace('https:', '');
                let slideIndex = $('.qv-product-images').find(`img[data-src='${imgSrc}']`).data('slick-index');

                $('.qv-product-images').slick('slickGoTo', slideIndex);

            }

            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

                $(product.variants).each(function (i, v) {

                    if (v.title == selectedOptions) {
                        var price = parseFloat(v.price / 100).toFixed(2);
                        var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                        var v_qty = v.inventory_quantity;
                        var v_inv = v.inventory_management;

                        $('.qv-product-price').text('$' + price);
                        $('.qv-product-original-price').text('$' + original_price);

                        if (v_inv == null) {
                            $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                        } else {
                            if (v.inventory_quantity < 1) {
                                $('.qv-add-button').prop('disabled', true).val('Sold Out');
                            } else {
                                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                            }
                        }
                    }
                });
            });
            
        });

        $.fancybox({
            href: '#quick-view',
            maxWidth: 1040,
            maxHeight: 600,
            fitToView: true,
            width: '100%',
            height: '80%',
            padding: 0,
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            'beforeLoad': function () {

                var product_handle = $('#quick-view').attr('class');

                $(document).on("click", ".qv-add-button", function () {
                    var qty = $('.qv-quantity').val();
                    var selectedOptions = '';
                    var var_id = '';
                    var comparePrice = 0;
                    var actualPrice = 0;

                    var firstProductSalePrice = 0;
                    var firstProductActualPrice = 0;

                    var sizeOption = $('#quick-view input[name="option-0"]:checked').val();
                    var colorOption = $('#quick-view input[name="option-1"]:checked').val();

                    if (sizeOption == undefined) {
                        selectedOptions = colorOption;
                    } else if (colorOption == undefined) {
                        selectedOptions = sizeOption;
                    } else {
                        selectedOptions = sizeOption + ' / ' + colorOption;
                    }

                    $(this).find('.loader').css('display', 'flex');

                    // crossSale Products
                    let mainProduct;
                    if ($('#quick-view').hasClass('qckCrossBundle1') || $('#quick-view').hasClass('qckCrossBundle2')) {
                        product_handle = product_handle.split(/[, ]+/).pop();
                        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                            $(product.variants).each(function (i, v) {
                                if (v.title == selectedOptions) {
                                    console.log(v);
                                    comparePrice = v.compare_at_price;
                                    actualPrice = v.price;
                                    updateValues(v.id,v.featured_image.src);
                                    $('.qv-add-button').find('.loader').css('display', 'none');
                                    $('.crossPrdctsAdd').removeClass('hidden');
                                }
                            });
                        });
                      
                        jQuery.getJSON('/products/' + $('.crossBundleMain').data('handle') + '.js', function (product) {
                          var firstProductSalePrice = product.compare_at_price;
                          var firstProductActualPrice = product.price;
                          
                            jQuery.ajax({
                                type: 'GET',
                                url: '/cart.js',
                                cache: false,
                                dataType: 'json',
                                success: function(cart) {
                                    let items=[];
                                    jQuery.each(cart.items, function(item) {
                                        items.push(cart.items[item].id);
                                    });
                                    jQuery('.bndlTitle .hd').html('Your Bundle');
                                    jQuery('.qv-add-button .text').html('Added');
                                    
                                    jQuery.each(product.variants, function(variant) {
                                      
                                        if ($.inArray(product.variants[variant].id, items) != -1) {
                                            $('.crossBundleMain').removeClass('hidden');
                                            $('.crossBundleMain').data('handle', product.variants[variant].handle);
                                            $('.crossBundleMain .crossPrdctImg img').attr('src', product.variants[variant].featured_image.src);
                                            $('.crossBundleMain .prdctTitle').data('handle', product.variants[variant].handle);
                                            $('.crossBundleMain .prdctTitle').html(product.title);
                                            $('.crossBundleMain .prdctVariantSize').html(`Size: ${product.variants[variant].option1}`);
                                            $('.crossBundleMain .prdctVariantColor').html(`Colour: ${product.variants[variant].option2}`);
                                            $('.crossBundleMain .prc_bundle .discounted').html('$'+ product.variants[variant].price / 100);
                                            $('.crossBundleMain .prc_bundle .undiscaunted').html('$'+ product.variants[variant].compare_at_price / 100 + ' RRP');
                                        }
                                    });
                                }
                            });
                        });

                        function updateValues(variant,variantImage) {
                            if ($('#quick-view').hasClass('qckCrossBundle1')) {
                                 console.log(variant);                           
                                crossSaleBundle.bundle1.variant = variant;
                                crossSaleBundle.bundle1.qty = qty;
                                crossSaleBundle.bundle1.sizeOption = sizeOption;
                                crossSaleBundle.bundle1.colorOption = colorOption;
                                crossSaleBundle.bundle1.selectedOptions = selectedOptions;
                                crossSaleBundle.bundle1.actualPrice = actualPrice;
                                crossSaleBundle.bundle1.comparePrice = comparePrice;

                                $('.crossBundle1 .prdctTitle').html($('.crossBundle1 .prdctTitle').data("title"));
                                $('.crossBundle1 .crossPrdctImg img').attr('src', variantImage);
                                $('.crossBundle1 .prdctVariantSize').html(`Size: ${crossSaleBundle.bundle1.sizeOption}`);
                                $('.crossBundle1 .prdctVariantColor').html(`Colour: ${crossSaleBundle.bundle1.colorOption}`);
                                $('.crossBundle1 .prc_bundle .discounted').html('$'+ `${crossSaleBundle.bundle1.actualPrice * crossSaleBundle.bundle1.qty / 100}`);
                                $('.crossBundle1 .prc_bundle .undiscaunted').html('$'+ `${crossSaleBundle.bundle1.comparePrice * crossSaleBundle.bundle1.qty / 100}` +' RRP');
                                $('.crossBundle1 .absLinks, .crossBundle1 .prdctDesc').removeClass('hidden');
                              
                            } else if ($('#quick-view').hasClass('qckCrossBundle2')) {
                              
                                crossSaleBundle.bundle2.variant = variant;
                                crossSaleBundle.bundle2.qty = qty;
                                crossSaleBundle.bundle2.sizeOption = sizeOption;
                                crossSaleBundle.bundle2.colorOption = colorOption;
                                crossSaleBundle.bundle2.selectedOptions = selectedOptions;
                                crossSaleBundle.bundle2.actualPrice = actualPrice;
                                crossSaleBundle.bundle2.comparePrice = comparePrice;

                                $('.crossBundle2 .prdctTitle').html($('.crossBundle2 .prdctTitle').data("title"));
                                $('.crossBundle2 .crossPrdctImg img').attr('src', variantImage);
                                $('.crossBundle2 .prdctVariantSize').html(`Size: ${crossSaleBundle.bundle2.sizeOption}`);
                                $('.crossBundle2 .prdctVariantColor').html(`Colour: ${crossSaleBundle.bundle2.colorOption}`);
                                $('.crossBundle2 .prc_bundle .discounted').html('$'+ `${crossSaleBundle.bundle2.actualPrice * crossSaleBundle.bundle2.qty / 100}`);
                                $('.crossBundle2 .prc_bundle .undiscaunted').html('$'+ `${crossSaleBundle.bundle2.comparePrice * crossSaleBundle.bundle2.qty / 100}` +' RRP');
                                $('.crossBundle2 .absLinks, .crossBundle2 .prdctDesc').removeClass('hidden');
                            }
                        }

                                  
                    } else {
                        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                            $(product.variants).each(function (i, v) {
                                if (v.title == selectedOptions) {
                                    var_id = v.id;
                                    processCart();
                                }
                            });
                        });
    
                        function processCart() {
                            jQuery.post('/cart/add.js', {
                                    quantity: qty,
                                    id: var_id
                                },
                                null,
                                "json"
                            ).done(function (data) {
                                window.theme.ajaxSubmitCart().then( response => {
                                    $("body").addClass("cart-popup-open");
                                    $(".qv-add-button .text").html("Added to Cart!");
                                    if (document.body.classList.contains('template-cart')) {
                                        window.location.href = '/cart';
                                    }
                                  });
                            })
                            .fail(function ($xhr) {
                                var data = $xhr.responseJSON;
                                console.log(data.description);
                            });
                        }
                    }
                    
                });
                $('.fancybox-wrap').css('overflow', 'hidden !important');
            },
            'afterShow': function () {
                $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
                    $('.qv-product-images').addClass('loaded');
                });
            },
            'afterClose': function () {
                $('#quick-view').removeClass().empty();
            }
        });
    });

    // Remove crossBundle product
    $('.absLinks .remove').click(function (e) {
      if ($(this).parents('.crossPrdct').hasClass('crossBundle1')) {
        crossSaleBundle.bundle1.variant = 1;
        crossSaleBundle.bundle1.qty = 1;
        crossSaleBundle.bundle1.sizeOption = '';
        crossSaleBundle.bundle1.colorOption = '';
        crossSaleBundle.bundle1.selectedOptions = '';
        crossSaleBundle.bundle1.actualPrice = 0;
        crossSaleBundle.bundle1.comparePrice = 0;
        $('.crossBundle1 .prdctTitle').html('+ Add 100% Organic Bamboo Sheet Sets (43cm Depth) to your bundle');
        $('.crossBundle1 .discounted').html('');
        
      } else if ($(this).parents('.crossPrdct').hasClass('crossBundle2')) {
        crossSaleBundle.bundle2.variant = 1;
        crossSaleBundle.bundle2.qty = 1;
        crossSaleBundle.bundle2.sizeOption = '';
        crossSaleBundle.bundle2.colorOption = '';
        crossSaleBundle.bundle2.selectedOptions = '';
        crossSaleBundle.bundle2.actualPrice = 0;
        crossSaleBundle.bundle2.comparePrice = 0;
        $('.crossBundle2 .prdctTitle').html('+ Add Organic Bamboo Standard Pillowcases (Pair) to your bundle');
        $('.crossBundle2 .discounted').html('');
      }
      $(this).parent().addClass('hidden');
      $(this).parents('.crossPrdct').find('.prdctDesc').addClass('hidden');
      if (crossSaleBundle.bundle1.variant === 1 && crossSaleBundle.bundle2.variant === 1) {
          $('.crossBundleMain, .crossPrdctsAdd').addClass('hidden');
      }
    });


    $('.crossSale_qlt .crossAdd').click(function() {
        $('.crossSale_qlt .crossAdd').html('ADDING...');
        let items = [];
        let item1, 
            item2;
        for (const item in crossSaleBundle) {
            if (crossSaleBundle[item].variant !== 1) {    
                if (item === 'bundle1') {
                    item1 = {id:crossSaleBundle[item].variant,quantity:crossSaleBundle[item].qty,properties: { "_cross_Sale": "Yes"}};
                } else {
                    item2 = {id:crossSaleBundle[item].variant,quantity:crossSaleBundle[item].qty,properties: { "_cross_Sale": "Yes"}};
                }
            }
        }
        if (typeof item1 !== "undefined") {
            items.push(item1);
        }
        if (typeof item2 !== "undefined") {
            items.push(item2);
        }
      
        jQuery.post('/cart/add.js', {
                items
            },
            null,
            "json"
        ).done(function (data) {
            window.theme.ajaxSubmitCart().then( response => {
                $('.crossSale_qlt .crossAdd').html('ADDED');
                $('.absLinks').hide();
                $("body").addClass("cart-popup-open");
              });
        })
        .fail(function ($xhr) {
            var data = $xhr.responseJSON;
            console.log(data.description);
        });
    });
}; 

$(window).resize(function () {
    if ($('#quick-view').is(':visible')) {
        $('.qv-product-images').slick('setPosition');
    }
}); 

$(document).on("click", ".qv-add-button, .absLinks .remove", function () {
setTimeout(function() {
                      var productMainPrice = 0;
                      var productMainPriceSale = 0;
                      
                      var product1Price = 0;
                      var product1PriceSale = 0;
                      
                      var product2Price = 0;
                      var product2PriceSale = 0;

                      if( isNaN($('.crossBundleMain .discounted').html()) ){
                        productMainPrice = $('.crossBundleMain .discounted').html();
                        productMainPrice = parseInt( productMainPrice.replace(/[^0-9]/g, '') );

                        productMainPriceSale = $('.crossBundleMain .undiscaunted').html();
                        productMainPriceSale = parseInt( productMainPriceSale.replace(/[^0-9]/g, '') );
                        
                      }

                      if( isNaN($('.crossBundle1 .discounted').html()) ){
                        product1Price = $('.crossBundle1 .discounted').html(); 
                        product1Price = parseInt( product1Price.replace(/[^0-9]/g, '') );

                        product1PriceSale = $('.crossBundle1 .undiscaunted').html();
                        product1PriceSale = parseInt( product1PriceSale.replace(/[^0-9]/g, '') );
                      }

                      if( isNaN($('.crossBundle2 .discounted').html()) ){
                        product2Price = $('.crossBundle2 .discounted').html(); 
                        product2Price = parseInt( product2Price.replace(/[^0-9]/g, '') );

                        product2PriceSale = $('.crossBundle2 .undiscaunted').html();
                        product2PriceSale = parseInt( product2PriceSale.replace(/[^0-9]/g, '') );
                      }

                      var bundlePrice = productMainPrice + product1Price + product2Price;
                      var bundleSalePrice = productMainPriceSale + product1PriceSale + product2PriceSale;
                      var bundleTotal = bundlePrice + bundleSalePrice;
                      bundlePrice = bundlePrice.toFixed(2);
                      bundleSalePrice = bundleSalePrice.toFixed(2);
                      bundleTotal = bundleTotal.toFixed(2);

                      $('.bndlTotal .bndlActual').html('Subtotal: $'+ bundleTotal + ' RRP');
                      $('.bndlTotal .payActual').html('You Pay: $'+ bundlePrice);
                      $('.bndlTotal .paySaving').html('BUNDLE SAVINGS -$'+ bundleSalePrice);
                      $('.bndlTotal').show();

                      if( !isNaN($('.crossBundle1 .discounted').html()) && !isNaN($('.crossBundle2 .discounted').html()) ){
                        $('.bndlTotal').hide();
                        jQuery('.bndlTitle .hd').html('Bundle and save up to $251.00!');
                      }
                      
                    }, 3000);
});                    